// Port of api/fuel/app/classes/filter/ratings.php
import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'

var Ratings = Filter.extend({
	filter_type: F.TYPE_GAMES,
	cache_type: F.CACHE_RATINGS,
	result_type: F.RESULT_RATING,
	pseudo_type: F.PSEUDO_RATING,
	json_package: 'ratings',
	package_types: [F.PACKAGE_GAME, F.PACKAGE_RATING],
	required_filter: {
		source: {
			ratings: true
		}
	},

	configure: function(config) {
		if (config.ownerType !== F.OWNER_USER) {
			config.resultType = F.RESULT_GAME
		}
		return config
	},

	search: function(data) {
		data = Filter.prototype.search.call(this, data)
		data.maximum = this._config.owner.get_count_ratings ? this._config.owner.get_count_ratings() : data.maximum
		return data
	}
})

export default Ratings
